


// product details

export const checkOutOrderTotal = "checkOutOrderTotal"
export const checkOrderTotalLoaded = "checkOrderTotalLoaded"
export const checkOrderFeedStatus =  "checkOrderFeedStatus"
export const selectBranchForCheckout = "selectBranchForCheckout"
export const CHECK_VOUCHER = "CHECK_VOUCHER_AVAIL"
export const CHECK_ORDER_TYPE = "CHECK_ORDER_TYPE"
export const CHANGE_DELIVERY_TYPE ="CHANGE_DELIVERY_TYPE"
// checkout


// product details page
